import script from "./RevisitPath.vue?vue&type=script&setup=true&lang=js"
export * from "./RevisitPath.vue?vue&type=script&setup=true&lang=js"

import "./RevisitPath.vue?vue&type=style&index=0&id=9dd94468&lang=scss"
import "./RevisitPath.vue?vue&type=style&index=1&id=9dd94468&scoped=true&lang=scss"

import exportComponent from "/builds/gu1sQVEd/1/fe-huihui/fed-doctor-helper-ms/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9dd94468"]])

export default __exports__